import React, {useEffect} from "react";
import "./style.css";
import {Price} from "../Price/Price";
import {getSKUS} from "../../../../../../config/config";

import { Image } from "../../../../../../components/Image";
export const Pay = ({time, timeInSeconds, setShowPopup, targetRef, sku, curPriceIndex, scrollToBottom, showSkuModule = true, ...props}) => {

  const renderWeek = () => {
    const price = sku.prices[curPriceIndex];
    const finalWeek = price.getFinalWeek();
    return finalWeek === 1 ? "week" : `${finalWeek} weeks`;
  }

  const getRegularSku = () => {
    return getSKUS()?.[0];
  }

  return (
    <div className="pay" ref={targetRef}>
      <div className="plan-container">
        <p className="plan-title">
          <span className="span">Grab your Personalized </span>
          <br/>
          <span className="text-wrapper-2">Weight Loss</span>
          <span className="span">{" "}Plan</span>
          <br/>
          <span className="span">
            before it&#39;s gone!
          </span>
        </p>

        {timeInSeconds > 0 && (
          <div className="offer-info">
            <div className="offer-icon">
              <Image src="/static/image/questionnaire/weight-loss/payScreen/vector-313-1.svg" alt="Vector" className="vector" />
            </div>

            <p className="offer-text">This offer ends in {time} min</p>
          </div>
        )}
      </div>
      {showSkuModule && <Price sku={sku} curPriceIndex={curPriceIndex} {...props} />}

      <div className="download-2">
        <div className="money-back-guarantee" onClick={scrollToBottom}>30 Day Money-Back Guarantee</div>
        <button className="button-text-wrapper btn-ripple" onClick={() => {setShowPopup(true)}}>
          <div className="button-text-2">Get my plan</div>
        </button>

      </div>
      <div className="disclaimer-text-wrapper">
        <p className="disclaimer-text">
          <span className="text-wrapper-3">
            By clicking Get My Plan, I agree that my subscription will be auto-renewed at the full price of <span > {getRegularSku().prices[curPriceIndex].getFinalPrice()} </span> every <span > {renderWeek()} </span> after the intro plan unless I cancel by emailing website@caloapp.ai.
          </span>
        </p>
      </div>

    </div>
  );
};
